var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main"},[_vm._v("\t\t\t\t\n\t©  "),_c('b',[_vm._v("Marquez Express Inc. EIN 47-3494431")])])
}]

export { render, staticRenderFns }